import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import CustomizedProgressBar from "../../Components/LinearDeterminate";
import { CloseOutlined, KeyboardArrowLeft } from "@mui/icons-material";
import MultilineText from "../../Components/MultilineText";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ScrollBar } from "../../Components/ScrollBar";
import { CircularProgress } from "@mui/material";
import Button from "../../Components/Button";
import BookingResultModal from "./Modal";
import dayjs from "dayjs";
import "./style.css";

function StepFour() {
  const {
    selectedSpecialization,
    selectedDoctorBySearch,
    convertToStandardTime,
    showSubmissionError,
    toSearchByDoctor,
    setDisplayAlert,
    selectedPolicy,
    selectedDoctor,
    selectedClinic,
    handleSubmit,
    selectedDate,
    selectedTime,
    handleBack,
    isLoading,
    setNotes,
    notes,
  } = useConsultDoctorContext();

  const handleChange = (e) => {
    setNotes(e.target.value);
  };

  let resultModal = showSubmissionError && <BookingResultModal />;

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeft
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center text-md font-bold flex-1">
              Consult a doctor
            </div>
            <CloseOutlined
              className=" cursor-pointer"
              onClick={() => setDisplayAlert(true)}
            />
          </div>
          <div className="p-3">
            <CustomizedProgressBar value={100} />
          </div>
        </div>
        <div className="w-full px-3">
          <div className="text-lg font-bold">Booking Summary</div>
          <div className="text-sm text-[#60656D]">
            Review and confirm your appointment details.
          </div>
        </div>

        <ScrollArea.Root className="w-full">
          <ScrollArea.Viewport className="w-full min-h-[200px] h-[calc(100vh-218px)] sm:h-full rounded">
            <div className="px-3 mt-3">
              <div className="text-sm text-[#60656D]">Appointment type</div>
              <div className="text-sm">Doctor Consult</div>
            </div>
            <div className="px-3 mt-2">
              <div className="text-sm text-[#60656D]">Patient's name</div>
              <div className="text-sm">
                {selectedPolicy?.firstName +
                  " " +
                  selectedPolicy?.middleName +
                  " " +
                  selectedPolicy?.lastName +
                  " " +
                  selectedPolicy?.suffixName}
              </div>
            </div>
            <div className="px-3 mt-2">
              <div className="text-sm text-[#60656D]">PCC branch</div>
              <div className="text-sm">{selectedClinic?.providerName}</div>
            </div>
            <div className="px-3 mt-2">
              <div className="text-sm text-[#60656D]">Date</div>
              <div className="text-sm">
                {dayjs(selectedDate).format("MMMM DD, YYYY")}
              </div>
            </div>
            <div className="px-3 mt-2">
              <div className="text-sm text-[#60656D]">Time</div>
              <div className="text-sm">
                {selectedTime ? convertToStandardTime(selectedTime) : null}
              </div>
            </div>
            <div className="px-3 mt-2">
              <div className="text-sm text-[#60656D]">Doctor Name</div>
              <div className="text-sm">
                {toSearchByDoctor
                  ? selectedDoctorBySearch?.name
                  : selectedDoctor?.name}
              </div>
            </div>
            <div className="px-3 mt-2">
              <div className="text-sm text-[#60656D]">Type of doctor</div>
              <div className="text-sm">
                {toSearchByDoctor
                  ? selectedDoctorBySearch?.specializationName
                  : selectedSpecialization?.name}
              </div>
            </div>
            <div className="px-3 mt-2 ">
              <div className="text-sm font-bold">Notes/concern (optional)</div>
              <MultilineText
                value={notes}
                onChange={(e) => handleChange(e)}
                inputProps={{
                  maxLength: 250,
                }}
              />
            </div>
          </ScrollArea.Viewport>
          <ScrollBar />
        </ScrollArea.Root>

        <div className="flex w-full p-4 mt-auto sm:justify-end">
          <Button
            id="consultSubmitButton"
            className={`h-14 w-full sm:w-22.5 ${
              isLoading ? "bg-[#F6F7F7]" : "bg-[#0053CC]"
            } rounded-xl`}
            onClick={handleSubmit}
          >
            <p
              className={`font-medium font-sans text-xs ${
                isLoading ? "text-[#A3A7AB]" : "text-white"
              }`}
            >
              {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
            </p>
          </Button>
        </div>
      </div>
      {resultModal}
    </div>
  );
}

export default StepFour;
